(function () {
    'use strict';

    angular.module('swif.ui')
    .config(router)
    .directive('swifOauthLogin', oauthLoginDirective);


    function router ($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/oauth/provider_table_view', {
            templateUrl: 'partials/ui/oauth_provider_table_view.html',
            controller: OauthProviderController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    
    function OauthProviderController ($scope, $location, swif) {
        'ngInject';
        swif.collection.createOrUpdate(
            'oauth_providers', 'oauth_provider'
        ).then(function (collection) {
            $scope.providers = collection;
        });
        var swif_site = window.location.pathname.replace(/\//g, '');
        var base_url = window.location.href.split('#')[0];

        $scope.preModal = function (data){
            $scope.providers.preModal(data);
            if (data.action.id === 'add') {
                let ozwillo_uri = '';
                if ($location.host === 'ozwillo-staging.opengst.fr') {
                    ozwillo_uri = 'https://accounts.ozwillo-preprod.eu';
                } else if ($location.host === 'ozwillo.opengst.fr') {
                    ozwillo_uri = 'https://accounts.ozwillo.com';
                }
                if (ozwillo_uri) {
                    _.defaults(data.model, {
                        name: 'ozwillo provider',
                        auth_type: 'auth_code',
                        client_id: swif_site,
                        redirect_uri: base_url + 'oauth_callback.html',
                        auth_endpoint: ozwillo_uri + '/a/auth',
                        scope: 'openid profile email',
                        validation_endpoint: ozwillo_uri + '/a/tokeninfo',
                        token_endpoint: ozwillo_uri + '/a/token',
                        data_endpoint: ozwillo_uri + '/a/userinfo',
                        logout_endpoint: ozwillo_uri + '/a/logout',
                        revoke_endpoint: ozwillo_uri + '/a/revoke',
                        logout_redirect_uri: base_url,
                        enabled: true,
                        create_user: true,
                        sequence: 0
                    });
                }
            }

        };
        $scope.preValidate = function (data) {
            return $scope.providers.preValidate(data);
        };
        $scope.callback = function(error, data) {
            $scope.providers.callback(error, data);
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:oauthLoginDirective
    * @module swif.ui
    * @restrict E
    * @description display the needed links to login via services
    **/
    function oauthLoginDirective(swifOAuthService) {
        'ngInject';
        var directive = {
            restrict: 'E',
            scope: {},
            templateUrl: 'partials/ui/oauth_providers_login.html',
            link: function (scope) {
                swifOAuthService.getOauthProviders().then(function(providers) {
                    scope.providers = providers;
                });
            }
        };
        return directive;
    }


})();